module.exports = __webpack_public_path__ + "img/logo.5afb2c4e.png";